<script lang="ts">
    export let size: "sm" | "base" | "lg" = "base";
</script>

<div class:h-2={size === "sm"} class:h-5={size === "base"} class:h-8={size === "lg"} class="w-full" />
